import { gql } from 'apollo-angular';

export const GET_CATEGORY_ATTRIBUTES = gql`
  query getCategoryAttributes(
    $categoryId: Long
    $schemeId: Long
    $searchValue: String
    $categoryAttributeTypes: [String]
  ) {
    productAttributeNamesByCategory(
      categoryId: $categoryId
      categorizationSchemeId: $schemeId
      searchValue: $searchValue
      categoryAttributeTypes: $categoryAttributeTypes
    ) {
      attributes {
        name
        value
      }
      attributeType
    }
  }
`;

export default GET_CATEGORY_ATTRIBUTES;
